import { Center, Stack, Text } from "@mantine/core";

const renderAnimation = (color: string) => (
  <svg
    width="10em"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 70"
  >
    <style>
      {`
      #e3WXgJ7Nv8L2_ts {
          animation: e3WXgJ7Nv8L2_ts__ts 1500ms linear infinite normal forwards;
      }
      @keyframes e3WXgJ7Nv8L2_ts__ts {
          0% {transform: translate(34.71855px,34.419489px) scale(1,1)}
          33.333333% {transform: translate(34.71855px,34.419489px) scale(1,1); animation-timing-function: cubic-bezier(0.25,1,0.25,1)}
          66.666667% {transform: translate(34.71855px,34.419489px) scale(1.2,1.2)}
          100% {transform: translate(34.71855px,34.419489px) scale(1,1)}
      }
      #e3WXgJ7Nv8L4_ts {
          animation: e3WXgJ7Nv8L4_ts__ts 1500ms linear infinite normal forwards;
      }
      @keyframes e3WXgJ7Nv8L4_ts__ts {
          0% {transform: translate(167.34795px,34.419497px) scale(1,1); animation-timing-function: cubic-bezier(0.25,1,0.25,1)}
          33.333333% {transform: translate(167.34795px,34.419497px) scale(1.4,1.4)}
          66.666667% {transform: translate(167.34795px,34.419497px) scale(1,1)}
          100% {transform: translate(167.34795px,34.419497px) scale(1,1)}
      }
      #e3WXgJ7Nv8L6_ts {
          animation: e3WXgJ7Nv8L6_ts__ts 1500ms linear infinite normal forwards;
      }
      @keyframes e3WXgJ7Nv8L6_ts__ts {
          0% {transform: translate(101.033257px,34.419497px) scale(1.4,1.4)}
          33.333333% {transform: translate(101.033257px,34.419497px) scale(1,1)}
          66.666667% {transform: translate(101.033257px,34.419497px) scale(1,1); animation-timing-function: cubic-bezier(0.25,1,0.25,1)}
          100% {transform: translate(101.033257px,34.419497px) scale(1.4,1.4)}
      }
      `}
    </style>
    <g
      id="e3WXgJ7Nv8L2_ts"
      transform="translate(34.71855,34.419489) scale(1,1)"
    >
      <g transform="translate(-24.419699,-24.4195)">
        <path
          d="M39.041,36.843c2.054,3.234,3.022,4.951,3.022,6.742c0,3.537-2.627,5.252-6.166,5.252-1.56,0-2.567-.002-5.112-1.326c0,0-1.649-1.509-5.508-1.354-3.895-.154-5.545,1.373-5.545,1.373-2.545,1.323-3.516,1.309-5.074,1.309-3.539,0-6.168-1.713-6.168-5.252c0-1.791.971-3.506,3.024-6.742c0,0,3.881-6.445,7.244-9.477c2.43-2.188,5.973-2.18,5.973-2.18h1.093v-.001c0,0,3.698-.009,5.976,2.181c3.259,3.142,7.241,9.476,7.241,9.475ZM16.631,20.878c3.7,0,6.699-4.674,6.699-10.439s-2.999-10.439-6.699-10.439-6.699,4.674-6.699,10.439s2.999,10.439,6.699,10.439Zm-6.42,10.11c2.727-1.259,3.349-5.723,1.388-9.971s-5.761-6.672-8.488-5.414-3.348,5.723-1.388,9.971c1.961,4.248,5.761,6.671,8.488,5.414Zm21.995-10.11c3.7,0,6.7-4.674,6.7-10.439s-3-10.439-6.7-10.439-6.699,4.674-6.699,10.439s2.999,10.439,6.699,10.439Zm13.521-5.276c-2.728-1.259-6.527,1.165-8.488,5.414s-1.339,8.713,1.389,9.972c2.728,1.258,6.527-1.166,8.488-5.414s1.339-8.713-1.389-9.972Z"
          fill={color}
        />
      </g>
    </g>
    <g
      id="e3WXgJ7Nv8L4_ts"
      transform="translate(167.34795,34.419497) scale(1,1)"
    >
      <g transform="translate(-24.419695,-24.4195)">
        <path
          d="M39.041,36.843c2.054,3.234,3.022,4.951,3.022,6.742c0,3.537-2.627,5.252-6.166,5.252-1.56,0-2.567-.002-5.112-1.326c0,0-1.649-1.509-5.508-1.354-3.895-.154-5.545,1.373-5.545,1.373-2.545,1.323-3.516,1.309-5.074,1.309-3.539,0-6.168-1.713-6.168-5.252c0-1.791.971-3.506,3.024-6.742c0,0,3.881-6.445,7.244-9.477c2.43-2.188,5.973-2.18,5.973-2.18h1.093v-.001c0,0,3.698-.009,5.976,2.181c3.259,3.142,7.241,9.476,7.241,9.475ZM16.631,20.878c3.7,0,6.699-4.674,6.699-10.439s-2.999-10.439-6.699-10.439-6.699,4.674-6.699,10.439s2.999,10.439,6.699,10.439Zm-6.42,10.11c2.727-1.259,3.349-5.723,1.388-9.971s-5.761-6.672-8.488-5.414-3.348,5.723-1.388,9.971c1.961,4.248,5.761,6.671,8.488,5.414Zm21.995-10.11c3.7,0,6.7-4.674,6.7-10.439s-3-10.439-6.7-10.439-6.699,4.674-6.699,10.439s2.999,10.439,6.699,10.439Zm13.521-5.276c-2.728-1.259-6.527,1.165-8.488,5.414s-1.339,8.713,1.389,9.972c2.728,1.258,6.527-1.166,8.488-5.414s1.339-8.713-1.389-9.972Z"
          fill={color}
        />
      </g>
    </g>
    <g
      id="e3WXgJ7Nv8L6_ts"
      transform="translate(101.033257,34.419497) scale(1.4,1.4)"
    >
      <g transform="translate(-24.419699,-24.419488)">
        <path
          d="M39.041,36.843c2.054,3.234,3.022,4.951,3.022,6.742c0,3.537-2.627,5.252-6.166,5.252-1.56,0-2.567-.002-5.112-1.326c0,0-1.649-1.509-5.508-1.354-3.895-.154-5.545,1.373-5.545,1.373-2.545,1.323-3.516,1.309-5.074,1.309-3.539,0-6.168-1.713-6.168-5.252c0-1.791.971-3.506,3.024-6.742c0,0,3.881-6.445,7.244-9.477c2.43-2.188,5.973-2.18,5.973-2.18h1.093v-.001c0,0,3.698-.009,5.976,2.181c3.259,3.142,7.241,9.476,7.241,9.475ZM16.631,20.878c3.7,0,6.699-4.674,6.699-10.439s-2.999-10.439-6.699-10.439-6.699,4.674-6.699,10.439s2.999,10.439,6.699,10.439Zm-6.42,10.11c2.727-1.259,3.349-5.723,1.388-9.971s-5.761-6.672-8.488-5.414-3.348,5.723-1.388,9.971c1.961,4.248,5.761,6.671,8.488,5.414Zm21.995-10.11c3.7,0,6.7-4.674,6.7-10.439s-3-10.439-6.7-10.439-6.699,4.674-6.699,10.439s2.999,10.439,6.699,10.439Zm13.521-5.276c-2.728-1.259-6.527,1.165-8.488,5.414s-1.339,8.713,1.389,9.972c2.728,1.258,6.527-1.166,8.488-5.414s1.339-8.713-1.389-9.972Z"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

const color = "#6ba0ca";

export function FancyLoader({ children }: { children?: React.ReactNode }) {
  return (
    <Center h="80vh">
      <Stack>
        {renderAnimation(color)}
        {children ?? (
          <Text ta="center" c="blue" w="bold" size="1.5em">
            {children}
          </Text>
        )}
      </Stack>
    </Center>
  );
}

export const FancyInlineLoader = () => renderAnimation(color);
